module.exports = __webpack_public_path__ + "img/close.509ee276.svg";